import { gql } from '@apollo/client'

export const RESERVATION_UPDATE = gql`
  subscription OnUpdateReservation(
    $clientName: String!
    $prospectToken: JWT!
    $reservationId: UUID!
  ) {
    getReservationUpdate(
      clientName: $clientName
      prospectToken: $prospectToken
      reservationId: $reservationId
    ) {
      clientName
      prospectId
      reservationId
      signatureDate
      isPrimaryBuyer
      currentStep
      builderStatus
    }
  }
`

export const LOT_UPDATE = gql`
  subscription OnLotUpdate($clientName: String!) {
    getLotSalesStatus(clientName: $clientName) {
      lotId
      salesStatus
    }
  }
`

export const BUILDER_STATUS = gql`
  subscription OnUpdateBuilderStatus(
    $clientName: String!
    $prospectToken: JWT!
    $reservationId: UUID!
  ) {
    getBuilderStatus(
      clientName: $clientName
      prospectToken: $prospectToken
      reservationId: $reservationId
    )
  }
`

export const PROSPECT_BROCHURE_CREATED = gql`
  subscription OnProspectBrochureCreated($brochureUUID: UUID!) {
    prospectBrochureCreated(brochureUUID: $brochureUUID) {
      __typename
      brochureUUID
      ... on ProspectBrochureData {
        brochureUrl
      }
      ... on ProspectBrochureError {
        error
      }
    }
  }
`
